var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { api } from '../../../helpers/Api';
import { action, observable, runInAction } from 'mobx';
var CivitripClientStore = /** @class */ (function () {
    function CivitripClientStore() {
        this.civitripClient = null;
        this.clients = [];
        this.isLoading = false;
        this.error = null;
    }
    CivitripClientStore.prototype.read = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.isLoading = true;
                this.error = null;
                return [2 /*return*/, api.get("civitrip/clients/".concat(name)).then(function (client) {
                        runInAction(function () {
                            _this.civitripClient = client;
                            _this.isLoading = false;
                        });
                        return client;
                    }).catch(function (error) {
                        runInAction(function () {
                            var _a, _b;
                            if ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                                _this.error = error.response.data.message;
                            }
                            else {
                                _this.error = error.message;
                            }
                            _this.civitripClient = null;
                            _this.isLoading = false;
                        });
                        return Promise.reject(error);
                    })];
            });
        });
    };
    CivitripClientStore.prototype.create = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var newClient_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        this.error = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.post("civitrip/clients", data)];
                    case 2:
                        newClient_1 = _a.sent();
                        runInAction(function () {
                            _this.civitripClient = newClient_1;
                            _this.isLoading = false;
                        });
                        return [2 /*return*/, newClient_1];
                    case 3:
                        error_1 = _a.sent();
                        runInAction(function () {
                            _this.error = error_1.message;
                            _this.isLoading = false;
                        });
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CivitripClientStore.prototype.update = function (name, data) {
        return __awaiter(this, void 0, void 0, function () {
            var updatedClient_1, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.put("civitrip/clients/".concat(name), data)];
                    case 1:
                        updatedClient_1 = _a.sent();
                        runInAction(function () {
                            if (_this.civitripClient && _this.civitripClient.name === name) {
                                _this.civitripClient = updatedClient_1;
                            }
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        runInAction(function () {
                            _this.error = error_2.message;
                            _this.isLoading = false;
                        });
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CivitripClientStore.prototype.sendStretchesToCivitrip = function (stretches) {
        return api.post("civitrip/experiences", { stretches: stretches });
    };
    __decorate([
        observable
    ], CivitripClientStore.prototype, "civitripClient", void 0);
    __decorate([
        observable
    ], CivitripClientStore.prototype, "clients", void 0);
    __decorate([
        observable
    ], CivitripClientStore.prototype, "isLoading", void 0);
    __decorate([
        observable
    ], CivitripClientStore.prototype, "error", void 0);
    __decorate([
        action
    ], CivitripClientStore.prototype, "read", null);
    __decorate([
        action
    ], CivitripClientStore.prototype, "create", null);
    __decorate([
        action
    ], CivitripClientStore.prototype, "update", null);
    return CivitripClientStore;
}());
export default CivitripClientStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Acount/Civitrip/Store.ts
// module id = 759
// module chunks = 0